import { platform } from '@/shared/lib/platform/platform'

/**
 * Registra handler de deep link (`appUrlOpen` no nativo).
 * Na PWA retorna unsubscribe vazio (sem listener).
 */
export const onDeepLink = (handler: (url: URL) => void): (() => void) => {
  if (!platform.isNative()) {
    return () => {}
  }

  let disposed = false
  let removeListener: (() => void) | undefined

  void import('@capacitor/app')
    .then(({ App }) =>
      App.addListener('appUrlOpen', (event) => {
        if (disposed) {
          return
        }
        try {
          handler(new URL(event.url))
        } catch {
          // URL inválida — ignorar
        }
      }),
    )
    .then((handle) => {
      if (disposed) {
        void handle.remove()
        return
      }
      removeListener = () => {
        void handle.remove()
      }
    })

  return () => {
    disposed = true
    removeListener?.()
  }
}
